import commonUtils from '@/utils/commonUtils'
import {
  BoardListItem,
  getBadgeLabel,
  getMobileBadgeClass,
  searchMessages,
  withDrawnCumtomer,
} from '../boardItem'
import '../boardMobile.css'
import numberUtils from '@/utils/numberUtils'
import { Badge } from '@/components'
import { useAppSelector } from '@/redux/hooks'
import { useDialog } from '@/context/dialogContext'
import { useNavigate } from 'react-router-dom'
interface BoardTableProps {
  boardList: BoardListItem[]
  fieldNames?: string[]
  handleDetailView: (nttSn: number) => void
}

export const ViewIcon = () => {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="-102.4 -102.4 1228.80 1228.80"
      xmlns="http://www.w3.org/2000/svg"
      fill="#d9d9d9"
      stroke="#d9d9d9"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0}></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth={8.192}
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#d9d9d9"
          d="M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448zm0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z"
        ></path>
      </g>
    </svg>
  )
}
export const InquiryBoardTableMobile: React.FC<BoardTableProps> = ({
  boardList,
  fieldNames,
  handleDetailView,
}) => {
  const navigate = useNavigate()

  const handleWrite = () => {
    navigate(`/inquiry/write`)
  }

  return (
    <div className="mobile-view">
      <div className="mobile-board-container">
        {/* <div className="mobile-board-header">
          <h1
            className="mobile-board-title"
            onClick={() => {
              navigate(`/inquiry`)
            }}
          >
            문의
          </h1>
          <button className="mobile-write-btn" onClick={handleWrite}>
            글쓰기
          </button>
        </div> */}

        {boardList.length > 0 ? (
          boardList.map((item) => (
            <div
              className="mobile-post-item"
              key={item.nttSn}
              onClick={() => handleDetailView(item.nttSn)}
            >
              <div className="mobile-post-header">
                <td className="title-col">
                  <span className={getMobileBadgeClass(item.bbsSj)}>
                    {getBadgeLabel(item.bbsSj)}
                  </span>
                  &nbsp;
                  {item.replyYn === 'Y' && (
                    <span className="mobile-category-tag mobile-category-reply">
                      {getBadgeLabel(item.replyYn)}
                    </span>
                  )}
                </td>
              </div>
              <div className="mobile-post-title">{item.nttSj}</div>
              <div className="mobile-post-meta">
                <div className="mobile-post-left-meta">
                  <span className="mobile-post-user">
                    {item.withDrawYn === 'Y'
                      ? withDrawnCumtomer.name
                      : item.cstId === ''
                        ? item.guestName || '비회원'
                        : item.nickName}
                  </span>
                  <span className="mobile-post-date">
                    {commonUtils.formatDate(item.regDate, false)}
                  </span>
                </div>
                <div className="mobile-post-right-meta">
                  <div className="mobile-post-views">
                    <span>views</span>
                    <span>{numberUtils.formatViewCount(item.readngCnt)}</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div id="noSearchResults" className="mobile-no-data">
            <div className="mobile-no-data-icon">📭</div>
            <div className="mobile-no-data-title">검색 결과가 없습니다</div>
            <div className="mobile-no-data-message">
              검색하신 조건에 맞는 게시글이 없습니다.
              <br />
              새로운 게시글을 등록하거나 다른 검색어로
              <br />
              다시 시도해 주세요.
            </div>
            {/* <div className="mobile-no-data-actions">
              <button
                className="mobile-no-data-btn primary"
                onClick={() => {
                  navigate(`/inquiry`)
                }}
              >
                목록으로
              </button>
              <button className="mobile-no-data-btn secondary">
                검색 조건 초기화
              </button>
            </div> */}
          </div>
        )}
      </div>
    </div>
  )
}
